import { BCMSDate } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";
export default function PickerHeader(props) {
    let { month1, month2, setViewDate, disabled } = props;

    return (
        <div className="picker-header">
            <span className="left-calendar-label">
                <b><MonthLeft setViewDate={setViewDate} viewDate={month1} disabled={disabled} /><span className='month'>{month1.getLongMonth}</span> <span className='year'>{month1.yearInt}</span></b>
            </span>
            <span className="right-calendar-label">
                <b><span className='month'>{month2.getLongMonth}</span> <span className='year'>{month2.yearInt}</span><MonthRight setViewDate={setViewDate} viewDate={month1} disabled={ disabled } /></b>
            </span>
        </div>
    )
}

export function MonthLeft(props) {
    let {setViewDate, viewDate} = props;
    const disabled = props.disabled.leftDisabled;

    let onClick = function () {
        if (disabled(viewDate) !== false) {
            setViewDate(
                viewDate.isFuture() && !viewDate.isEqual(BCMSDate.init().setToFirst())
                    ? viewDate : viewDate.offset([ 0, -1, 0])
            );
        }
    }

    return (
        <button className={`left-button ${disabled(viewDate) === false ? "disabled-month-chevron":""}`} onClick={onClick}><SVGAsset id="LeftChevronIcon"></SVGAsset></button>
    )
}

export function MonthRight(props) {
    const disabled = props.disabled.rightDisabled;

    let onClick = function () {
        if(disabled(props.viewDate) !== false) {
            props.setViewDate(
                props.viewDate.isPast() && !props.viewDate.isEqual(BCMSDate.init().setToFirst())
                    ? props.viewDate.offset([ 0, 1, 0])
                    : props.viewDate.offset([ 0, 2, 0 ])
            );
        }
    }
    return (
        <button className={ `right-button ${ disabled(props.viewDate) == false ? "disabled-month-chevron" : "" }` } onClick={onClick}><SVGAsset className="rotate-icon" id="LeftChevronIcon"></SVGAsset></button>
    )
}

